import { Box, Button, Typography } from '@mui/material';
import _ from 'lodash';
import { useGetRewardList } from '../../../hooks/useReward';
import { useCartStore } from '../../../stores/cartStore';
import CartItem from './CartItem';

const CartInfo = ({ disabledButton, onConfirm }) => {
  const redeemLists = useCartStore((state) => state.cart);
  const { data: rewardData } = useGetRewardList({ sort_col: 'point', sort_value: true });
  const listReward = rewardData?.Data?.data || [];

  return (
    <Box>
      {/* Title */}
      {redeemLists.length > 0 && (
        <Box
          sx={{
            backgroundColor: '#E1000C',
            color: 'white',
            padding: '2px 10px',
            borderRadius: '8px',
            textAlign: 'center',
            marginBottom: '20px',
          }}
        >
          <Typography component={'h1'} sx={{ fontSize: '1.75rem', fontWeight: '500' }}>
            โปรดตรวจสอบรายการสินค้า
          </Typography>
        </Box>
      )}

      {/* Reward Items > 0 */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {redeemLists.length > 0 &&
          redeemLists.map((item) => {
            const filtered = _.find(listReward, { _id: item.reward_id });

            return (
              <CartItem
                key={item.reward_id}
                id={item.reward_id}
                quantity={item.quantity}
                name={filtered && filtered.name}
                image={filtered && filtered.image}
                limit={filtered?.limit > 0 ? filtered.limit : undefined}
              />
            );
          })}
      </Box>

      {/* Reward Items === 0 */}
      <Box>
        {redeemLists.length === 0 && (
          <Box
            sx={{
              width: '100%',
              height: '150px',
              background: 'white',
              borderRadius: '8px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Typography
              sx={{ fontSize: '1.5rem', fontWeight: '700', textAlign: 'center', color: '#004B61' }}
            >
              ไม่มีรายการสินค้าในตะกร้า
            </Typography>
          </Box>
        )}
      </Box>

      {/* Consent */}
      <Box>
        <Box
          sx={{
            fontSize: '1.25rem',
            color: '#004B61',
            textAlign: 'center',
            margin: '10px 0 30px',
          }}
        >
          ของรางวัลอาจมีการเปลี่ยนแปลง สี หรือ รุ่น ในกรณีที่ของรางวัลหมด / เลิกผลิต
          เป็นรุ่นใกล้เคียงหรือเทียบเท่า
        </Box>
        <Box>
          <Button
            variant="contained"
            onClick={onConfirm}
            disabled={disabledButton}
            sx={{
              width: '150px',
              height: '45px',
              fontSize: '1.25rem',
              fontWeight: '500',
              display: 'block',
              margin: '0 auto',
              backgroundColor: '#E1000C',
              color: 'white',
              borderRadius: '6px',

              '&.Mui-disabled': {
                color: '#525252',
                backgroundColor: '#f5f5f5',
              },

              '&:hover': {
                color: 'white',
                backgroundColor: '#E1000C',
                opacity: '.85',
              },
            }}
          >
            ยืนยัน
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
export default CartInfo;
